export default __webpack_public_path__ + "media/DSC-DP.99b20556.png";